import api from './api'

// Personal access tokens for AI tools (Claude Code, Cursor, MCP clients) and scripts
export const apiTokenService = {
  getMeta: async () => {
    const response = await api.get('/api-tokens/meta')
    return response.data
  },

  list: async () => {
    const response = await api.get('/api-tokens')
    return response.data
  },

  // data: { name, scopes, expires_in_days, current_password } → { token, api_token }
  create: async (data) => {
    const response = await api.post('/api-tokens', data)
    return response.data
  },

  rename: async (id, name) => {
    const response = await api.put(`/api-tokens/${id}`, { name })
    return response.data
  },

  revoke: async (id) => {
    const response = await api.delete(`/api-tokens/${id}`)
    return response.data
  },

  // Admin only: every user's tokens, revoke any, and see what a token did
  adminList: async () => {
    const response = await api.get('/admin/api-tokens')
    return response.data
  },

  adminRevoke: async (id) => {
    const response = await api.delete(`/admin/api-tokens/${id}`)
    return response.data
  },

  adminAudit: async (id) => {
    const response = await api.get(`/admin/api-tokens/${id}/audit`)
    return response.data
  },

  // Admin only: organisation-wide AI access policy (on/off, lifetimes, permissions per role)
  getPolicy: async () => {
    const response = await api.get('/admin/ai-access-policy')
    return response.data
  },

  updatePolicy: async (patch) => {
    const response = await api.put('/admin/ai-access-policy', patch)
    return response.data
  },
}
